document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("#descargas a[href]").forEach(function (link) {
    if (link.classList.contains("pdf-download-btn")) return;

    const originalText = link.textContent.trim();
    if (!originalText) return;

    const normalizedText = originalText
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    let eyebrow = "Documento";
    let subtext = "Documentación del producto";

    if (normalizedText.includes("ficha")) {
      eyebrow = "Ficha técnica";
      subtext = "Documento técnico del producto";
    } else if (normalizedText.includes("manual")) {
      eyebrow = "Manual de instalación";
      subtext = "Guía de instalación y montaje";
    } else if (
      normalizedText.includes("certificado") ||
      normalizedText.includes("certificacion")
    ) {
      eyebrow = "Certificado";
      subtext = "Documentación y certificación";
    } else if (
      normalizedText.includes("instruccion") ||
      normalizedText.includes("instrucciones")
    ) {
      eyebrow = "Instrucciones";
      subtext = "Guía de uso del producto";
    }

    link.classList.add("pdf-download-btn");

    link.innerHTML = `
      <span class="pdf-download-btn__media" aria-hidden="true">
        <img
          src="https://cdn.shopify.com/s/files/1/0479/3617/6290/files/pdf_2.png?v=1730297080"
          alt=""
        >
      </span>

      <span class="pdf-download-btn__content">
        <span class="pdf-download-btn__eyebrow">${eyebrow}</span>
        <span class="pdf-download-btn__label">Descargar PDF</span>
        <span class="pdf-download-btn__subtext">${subtext}</span>
      </span>

      <span class="pdf-download-btn__arrow" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M12 4v10"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>

          <path
            d="M8.5 10.5L12 14l3.5-3.5"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>

          <path
            d="M5 19h14"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </span>
    `;
  });
});